import { Injectable } from '@angular/core';

@Injectable()
export class MyInfoMappingService {
  private countryCode: any;
  private maritalStatusCode: any;
  private residentialCode: any;
  private sexCode: any;
  constructor() {
    this.countryCode = [
      { key: 'AD', label: 'Andorran' },
      { key: 'AE', label: 'United Arab Emirates' },
      { key: 'AF', label: 'Afghan' },
      { key: 'AG', label: 'Antiguan' },
      { key: 'AL', label: 'Albanian' },
      { key: 'AM', label: 'Armenian' },
      { key: 'AO', label: 'Angolan' },
      { key: 'AR', label: 'Argentinian' },
      { key: 'AT', label: 'Austrian' },
      { key: 'AU', label: 'Australian' },
      { key: 'AZ', label: 'Azerbaijani' },
      { key: 'BA', label: 'Bosnian' },
      { key: 'BB', label: 'Barbados' },
      { key: 'BD', label: 'Bangladeshi' },
      { key: 'BE', label: 'Belgian' },
      { key: 'BF', label: 'Burkinabe' },
      { key: 'BG', label: 'Bulgarian' },
      { key: 'BH', label: 'Bahraini' },
      { key: 'BI', label: 'Burundian' },
      { key: 'BJ', label: 'Beninese' },
      { key: 'BL', label: 'Belarussian' },
      { key: 'BN', label: 'Bruneian' },
      { key: 'BO', label: 'Bolivian' },
      { key: 'BR', label: 'Brazilian' },
      { key: 'BS', label: 'Bahamian' },
      { key: 'BT', label: 'Bhutanese' },
      { key: 'BU', label: 'Myanmar' },
      { key: 'BW', label: 'Botswana' },
      { key: 'BZ', label: 'Belizean' },
      { key: 'CA', label: 'Canadian' },
      { key: 'CB', label: 'Croatian' },
      { key: 'CD', label: 'Democratic Republic Of The Congo' },
      { key: 'CF', label: 'Central African Republic' },
      { key: 'CG', label: 'Congolese' },
      { key: 'CH', label: 'Swiss' },
      { key: 'CI', label: 'Ivory Coast' },
      { key: 'CL', label: 'Chilean' },
      { key: 'CM', label: 'Cameroonian' },
      { key: 'CN', label: 'Chinese' },
      { key: 'CO', label: 'Colombian' },
      { key: 'CR', label: 'Costa Rican' },
      { key: 'CU', label: 'Cuban' },
      { key: 'CV', label: 'Cape Verdean' },
      { key: 'CY', label: 'Cypriot' },
      { key: 'CZ', label: 'Czech' },
      { key: 'DG', label: 'German' },
      { key: 'DJ', label: 'Djiboutian' },
      { key: 'DK', label: 'Danish' },
      { key: 'DM', label: 'Dominican' },
      { key: 'DO', label: 'Dominican (Republic)' },
      { key: 'DZ', label: 'Algerian' },
      { key: 'EC', label: 'Ecuadorian' },
      { key: 'EG', label: 'Egyptian' },
      { key: 'EN', label: 'Estonian' },
      { key: 'ER', label: 'Eritrean' },
      { key: 'ES', label: 'Spanish' },
      { key: 'ET', label: 'Ethiopian' },
      { key: 'FI', label: 'Finnish' },
      { key: 'FJ', label: 'Fijian' },
      { key: 'FR', label: 'French' },
      { key: 'GA', label: 'Gabon' },
      { key: 'GB', label: 'British' },
      { key: 'GC', label: 'British Overseas Territories Citizen' },
      { key: 'GD', label: 'Grenadian' },
      { key: 'GE', label: 'British Overseas Citizen' },
      { key: 'GG', label: 'British National Overseas' },
      { key: 'GH', label: 'Ghanaian' },
      { key: 'GJ', label: 'British Protected Person' },
      { key: 'GM', label: 'Gambian' },
      { key: 'GN', label: 'Guinean' },
      { key: 'GO', label: 'Georgian' },
      { key: 'GQ', label: 'Equatorial Guinea' },
      { key: 'GR', label: 'Greek' },
      { key: 'GT', label: 'Guatemalan' },
      { key: 'GW', label: 'Guinean (Bissau)' },
      { key: 'GY', label: 'Guyanese' },
      { key: 'HK', label: 'Hong Kong' },
      { key: 'HN', label: 'Honduran' },
      { key: 'HT', label: 'Haitian' },
      { key: 'HU', label: 'Hungarian' },
      { key: 'ID', label: 'Indonesian' },
      { key: 'IE', label: 'Irish' },
      { key: 'IL', label: 'Israeli' },
      { key: 'IN', label: 'Indian' },
      { key: 'IQ', label: 'Iraqi' },
      { key: 'IR', label: 'Iranian' },
      { key: 'IS', label: 'Icelander' },
      { key: 'IT', label: 'Italian' },
      { key: 'JM', label: 'Jamaican' },
      { key: 'JO', label: 'Jordanian' },
      { key: 'JP', label: 'Japanese' },
      { key: 'KA', label: 'Cambodian' },
      { key: 'KE', label: 'Kenyan' },
      { key: 'KI', label: 'Kiribati' },
      { key: 'KM', label: 'Comoran' },
      { key: 'KP', label: 'Korean, North' },
      { key: 'KR', label: 'Korean, South' },
      { key: 'KW', label: 'Kuwaiti' },
      { key: 'KY', label: 'Kyrgyzstan' },
      { key: 'KZ', label: 'Kazakhstani' },
      { key: 'LA', label: 'Laotian' },
      { key: 'LB', label: 'Lebanese' },
      { key: 'LC', label: 'St. Lucia' },
      { key: 'LH', label: 'Lithuanian' },
      { key: 'LI', label: 'Liechtensteiner' },
      { key: 'LK', label: 'Sri Lankan' },
      { key: 'LR', label: 'Liberian' },
      { key: 'LS', label: 'Lesotho' },
      { key: 'LU', label: 'Luxembourger' },
      { key: 'LV', label: 'Latvian' },
      { key: 'LY', label: 'Libyan' },
      { key: 'MA', label: 'Moroccan' },
      { key: 'MB', label: 'Macedonian' },
      { key: 'MC', label: 'Monacan' },
      { key: 'MD', label: 'Moldavian' },
      { key: 'MF', label: 'Micronesian' },
      { key: 'MG', label: 'Madagasy' },
      { key: 'MH', label: 'Marshallese' },
      { key: 'MJ', label: 'Montenegrin' },
      { key: 'ML', label: 'Malian' },
      { key: 'MN', label: 'Mongolian' },
      { key: 'MO', label: 'Macao' },
      { key: 'MR', label: 'Mauritanean' },
      { key: 'MT', label: 'Maltese' },
      { key: 'MU', label: 'Mauritian' },
      { key: 'MV', label: 'Maldivian' },
      { key: 'MW', label: 'Malawian' },
      { key: 'MX', label: 'Mexican' },
      { key: 'MY', label: 'Malaysian' },
      { key: 'MZ', label: 'Mozambican' },
      { key: 'NA', label: 'Namibian' },
      { key: 'NE', label: 'Niger' },
      { key: 'NG', label: 'Nigerian' },
      { key: 'NI', label: 'Nicaraguan' },
      { key: 'NO', label: 'Norwegian' },
      { key: 'NP', label: 'Nepalese' },
      { key: 'NR', label: 'Nauruan' },
      { key: 'NT', label: 'Netherlands' },
      { key: 'NZ', label: 'New Zealander' },
      { key: 'OM', label: 'Omani' },
      { key: 'PA', label: 'Panamanian' },
      { key: 'PE', label: 'Peruvian' },
      { key: 'PG', label: 'Papua New Guinean' },
      { key: 'PH', label: 'Filipino' },
      { key: 'PK', label: 'Pakistani' },
      { key: 'PL', label: 'Polish' },
      { key: 'PN', label: 'Palestinian' },
      { key: 'PT', label: 'Portuguese' },
      { key: 'PW', label: 'Palauan' },
      { key: 'PY', label: 'Paraguayan' },
      { key: 'QA', label: 'Qatari' },
      { key: 'RF', label: 'Russian' },
      { key: 'RO', label: 'Romanian' },
      { key: 'RS', label: 'Serbian' },
      { key: 'RW', label: 'Rwandan' },
      { key: 'SA', label: 'Saudi Arabian' },
      { key: 'SB', label: 'Solomon Islander' },
      { key: 'SC', label: 'Seychellois' },
      { key: 'SD', label: 'Sudanese' },
      { key: 'SE', label: 'Swedish' },
      { key: 'SG', label: 'Singapore Citizen' },
      { key: 'SI', label: 'Slovenian' },
      { key: 'SK', label: 'Slovak' },
      { key: 'SL', label: 'Sierra Leone' },
      { key: 'SM', label: 'Sammarinese' },
      { key: 'SN', label: 'Senegalese' },
      { key: 'SO', label: 'Somali' },
      { key: 'SR', label: 'Surinamer' },
      { key: 'SS', label: 'Stateless' },
      { key: 'ST', label: 'Sao Tomean' },
      { key: 'SV', label: 'Salvadoran' },
      { key: 'SW', label: 'Kittian & Nevisian' },
      { key: 'SY', label: 'Syrian' },
      { key: 'SZ', label: 'Swazi' },
      { key: 'TD', label: 'Chadian' },
      { key: 'TG', label: 'Togolese' },
      { key: 'TH', label: 'Thai' },
      { key: 'TI', label: 'Tajikistani' },
      { key: 'TM', label: 'Turkmen' },
      { key: 'TN', label: 'Tunisian' },
      { key: 'TO', label: 'Tongan' },
      { key: 'TP', label: 'East Timorese' },
      { key: 'TR', label: 'Turk' },
      { key: 'TT', label: 'Trinidadian & Tobagonian' },
      { key: 'TV', label: 'Tuvalu' },
      { key: 'TW', label: 'Taiwanese' },
      { key: 'TZ', label: 'Tanzanian' },
      { key: 'UG', label: 'Ugandan' },
      { key: 'UK', label: 'British Subject' },
      { key: 'UN', label: 'Unknown' },
      { key: 'UR', label: 'Ukrainian' },
      { key: 'US', label: 'American' },
      { key: 'UY', label: 'Uruguayan' },
      { key: 'UZ', label: 'Uzbekistan' },
      { key: 'VA', label: 'Vatican City State (Holy See)' },
      { key: 'VC', label: 'St. Vincentian' },
      { key: 'VE', label: 'Venezuelan' },
      { key: 'VN', label: 'Vietnamese' },
      { key: 'VU', label: 'Ni-Vanuatu' },
      { key: 'WS', label: 'Samoan' },
      { key: 'XB', label: 'Refugee (Xxb)' },
      { key: 'XC', label: 'Refugee (Other Than Xxb)' },
      { key: 'YM', label: 'Yemeni' },
      { key: 'ZA', label: 'South African' },
      { key: 'ZM', label: 'Zambian' },
      { key: 'ZW', label: 'Zimbabwean' }];

    this.maritalStatusCode =
      [{ key: '1', label: 'Single' },
      { key: '2', label: 'Married' },
      { key: '3', label: 'Widowed' },
      { key: '5', label: 'Divorced' }];

    this.residentialCode =
      [{ key: 'A', label: 'Alien' },
      { key: 'C', label: 'Citizen' },
      { key: 'P', label: 'Permanent Resident' },
      { key: 'U', label: 'Unknown' },
      { key: 'N', label: 'Not applicable' }];

    this.sexCode =
      [{ key: 'F', label: 'Female' },
      { key: 'M', label: 'Male' },
      { key: 'U', label: 'Unkown' }];
  }

  getMyinfoCountryCodeMapping() {
    return this.countryCode;
  }

  getMyinfoMaritalStatusCodeMapping() {
    return this.maritalStatusCode;
  }

  getMyinfoResidentialCodeMapping() {
    return this.residentialCode;
  }

  getMyinfoSexCodeMapping() {
    return this.sexCode;
  }
}
